export const messages = {
  en: {
    basePrivilegeManage: {
      queryCondition: 'Query Conditions',
      inputPrivilegeName: 'Please enter privilege name',
      inputPrivilegeCode: 'Please enter privilege code',
      query: 'Query',
      privilegeInfo: 'Privilege Information',
      addPrivilege: 'Add Privilege',
      privilegeId: 'Privilege ID',
      privilegeName: 'Privilege Name',
      resourcePath: 'Resource Path',
      merchantType: 'Merchant Type',
      merchantName: 'Merchant Name',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    addBasePrivilege: {
      addPrivilege: 'Add Privilege',
      privilegeName: 'Privilege Name',
      inputPrivilegeName: 'Required, please enter privilege name',
      resourcePath: 'Resource Path',
      inputResourcePath: 'Required, please enter resource path',
      merchantType: 'Merchant Type',
      selectMerchantType: 'Required, please select merchant type',
      description: 'Description',
      inputDescription: 'Optional, please enter description',
      operationTeam: 'Operation Team',
      merchant: 'Merchant',
      devTeam: 'Development Team',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed',
      privilegeNameRequired: 'Privilege name is required',
      privilegeNameLength: 'Privilege name must be between 2-10 characters',
      resourcePathRequired: 'Resource path is required',
      resourcePathLength: 'Resource path must be between 1-200 characters',
      merchantTypeRequired: 'Merchant type is required'
    },
    editBasePrivilege: {
      editPrivilege: 'Edit Privilege',
      privilegeName: 'Privilege Name',
      inputPrivilegeName: 'Required, please enter privilege name',
      resourcePath: 'Resource Path',
      inputResourcePath: 'Required, please enter resource path',
      merchantType: 'Merchant Type',
      selectMerchantType: 'Required, please select merchant type',
      description: 'Description',
      inputDescription: 'Optional, please enter description',
      operationTeam: 'Operation Team',
      merchant: 'Merchant',
      devTeam: 'Development Team',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed',
      privilegeNameRequired: 'Privilege name is required',
      privilegeNameLength: 'Privilege name must be between 2-10 characters',
      resourcePathRequired: 'Resource path is required',
      resourcePathLength: 'Resource path must be between 2-200 characters',
      merchantTypeRequired: 'Merchant type is required',
      privilegeIdRequired: 'Privilege ID is required'
    },
    deleteBasePrivilege: {
      confirmOperation: 'Please confirm your operation',
      confirmDeletePrivilege: 'Are you sure to delete this privilege?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    basePrivilegeManage: {
      queryCondition: '查询条件',
      inputPrivilegeName: '请输入权限名称',
      inputPrivilegeCode: '请输入权限编码',
      query: '查询',
      privilegeInfo: '权限信息',
      addPrivilege: '添加权限',
      privilegeId: '权限ID',
      privilegeName: '权限名称',
      resourcePath: '资源路径',
      merchantType: '商户类型',
      merchantName: '商户名称',
      createTime: '创建时间',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    addBasePrivilege: {
      addPrivilege: '添加权限',
      privilegeName: '权限名称',
      inputPrivilegeName: '必填，请填写权限名称',
      resourcePath: '资源路径',
      inputResourcePath: '必填，请填写资源路径',
      merchantType: '商户类型',
      selectMerchantType: '必填，请选择商户类型',
      description: '描述',
      inputDescription: '选填，请填写描述',
      operationTeam: '运营团队',
      merchant: '商家',
      devTeam: '开发团队',
      cancel: '取消',
      save: '保存',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      privilegeNameRequired: '权限名称不能为空',
      privilegeNameLength: '权限名称必须在2至10字符之间',
      resourcePathRequired: '资源路径不能为空',
      resourcePathLength: '资源路径必须在1至200字符之间',
      merchantTypeRequired: '商户类型不能为空'
    },
    editBasePrivilege: {
      editPrivilege: '修改权限',
      privilegeName: '权限名称',
      inputPrivilegeName: '必填，请填写权限名称',
      resourcePath: '资源路径',
      inputResourcePath: '必填，请填写资源路径',
      merchantType: '商户类型',
      selectMerchantType: '必填，请选择商户类型',
      description: '描述',
      inputDescription: '选填，请填写描述',
      operationTeam: '运营团队',
      merchant: '商家',
      devTeam: '开发团队',
      cancel: '取消',
      save: '保存',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      privilegeNameRequired: '权限名称不能为空',
      privilegeNameLength: '权限名称必须在2至10字符之间',
      resourcePathRequired: '资源路径不能为空',
      resourcePathLength: '资源路径必须在2至200字符之间',
      merchantTypeRequired: '商户类型不能为空',
      privilegeIdRequired: '权限ID不能为空'
    },
    deleteBasePrivilege: {
      confirmOperation: '请确认您的操作',
      confirmDeletePrivilege: '确定删除该权限吗？',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}